<div [ngbTooltip]="helpTextTooltip" triggers="hover:blur">
  <fa-icon style="color: black" class="ml-2 c-pointer" [icon]="faQuestionCircle"></fa-icon>
</div>
<ng-template #helpTextTooltip><div [innerHtml]="text"></div></ng-template>
